module.exports = __webpack_public_path__ + "static/media/ChannelSong.Bangla.9bcc8155.jpg";